Controller = App.loadClass 'core::Angular/Controller'

class exports.ApiDataForwardingController extends Controller
    constructor: (@scope, @location, @stateParams, @http, Session) ->
        id = @stateParams.token
        @http.get "#{Config.get('api_url')}/transfer-data/#{id}"
        .then (response) =>
            transferData = response.data.data

            @http.get "#{Config.get('api_url')}/transfer-data-token/#{id}"
            .then (response) =>
                # This code is baaaaaasically the same as the login controller, but with a couple tweaks
                token = response.data.token

                Session.set 'Authorization', "Bearer #{token}"
                Session.set 'SafeLink', "Bearer #{token}"
                Session.set 'OriginalUser', "Bearer #{token}"
                Session.set 'AuthTime', new Date().getTime()

                @http.get "#{Config.get('api_url')}/me"
                .then (response) =>
                    Socket.whenopen () ->
                        Socket.socket.send response.data.id
                    Raven?.setUserContext response.data

                @location.url transferData.url
